import { InjectionToken } from '@angular/core';
import { CalendarEventPort } from '../ports/calendar-event.port';

export const CALENDAR_EVENT_SERVICE = new InjectionToken<CalendarEventPort>('CALENDAR_EVENT_SERVICE');
